export const HEAD_CONTENT_DATA_SUBSCRIPTIONS = require('./headContentData');
